import React, { PropTypes } from 'react';

import { ModelYear } from '@sm360/widget-commons-vehicle';

const Protection = ({ protection }) => {
    return (
        <div>
            <p>{protection.label}</p>
            <p>{protection.description}</p>
            <div dangerouslySetInnerHTML={{ __html: protection.htmlBlock }} />
        </div>
    );
};

Protection.propTypes = {
    protection: PropTypes.instanceOf(ModelYear.OptionModel).isRequired,
};

Protection.displayName = 'Protection';

export default Protection;



// WEBPACK FOOTER //
// ./src/components/ProtectionCategory/Protection/Protection.jsx